var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { merge } from 'lodash';
import { useMutation } from '@apollo/client';
import { classNames } from 'libs/react';
import { useDebounce } from 'libs/react';
import { useState } from 'libs/react';
import { ApolloError } from '@apollo/client';
import { Form } from 'components/form/Form';
import { React } from 'libs/react';
import './MutationForm.scss';
/**
 * @component MutationForm
 * @since 1.0.0
 */
export function MutationForm(props) {
    const { id, name, style, mutation, onProcess, onValidate } = Object.assign({ style: 'normal' }, props);
    const onSuccess = useDebounce(props.onSuccess);
    const onFailure = useDebounce(props.onFailure);
    const [processing, setProcessing] = useState(false);
    const [successful, setSuccessful] = useState(false);
    const [error, setError] = useState(null);
    const [mutate] = useMutation(mutation);
    /**
     * @function onSubmit
     * @since 1.0.0
     * @hidden
     */
    function onSubmit(values) {
        return __awaiter(this, void 0, void 0, function* () {
            setError(null);
            setProcessing(true);
            setSuccessful(false);
            if (onValidate) {
                try {
                    onValidate(values);
                }
                catch (error) {
                    if (error instanceof ApolloError) {
                        setError(error);
                        setProcessing(false);
                        setSuccessful(false);
                        return;
                    }
                }
            }
            let mutation;
            if (onProcess) {
                try {
                    mutation = onProcess(values);
                }
                catch (error) {
                    setProcessing(false);
                    setSuccessful(false);
                    return;
                }
            }
            else {
                mutation = {
                    variables: {
                        input: Object.assign({}, values)
                    }
                };
            }
            if (mutation.optimisticResponse) {
                mutation.optimisticResponse = merge(mutation.optimisticResponse, {
                    __typename: 'Mutation'
                });
            }
            try {
                const result = yield mutate(mutation);
                if (result == null) {
                    setProcessing(false);
                    setSuccessful(false);
                    return;
                }
                if (onSuccess) {
                    onSuccess(result.data, values);
                }
            }
            catch (error) {
                if (onFailure) {
                    onFailure(error, values);
                }
                setError(error);
                setProcessing(false);
                setSuccessful(false);
                return;
            }
            setProcessing(false);
            setSuccessful(true);
        });
    }
    const className = classNames('mutation-form', 'mutation-form--' + style, { 'mutation-form--has-error': error }, { 'mutation-form--is-processing': processing }, { 'mutation-form--is-successful': successful }, props.className);
    return (React.createElement(Form, { id: id, className: className, name: name, error: error, style: style, processing: processing, successful: successful, onSubmit: onSubmit }, props.children));
}
